import * as React from 'react';
import { TIME_FORMAT } from '../../constants';
import { classNames } from '@progress/kendo-react-common';
import { useInternationalization } from '@progress/kendo-react-intl';
/** @hidden */
export var DayViewRowContent = function (props) {
    var slot = props.slot, children = props.children;
    var intl = useInternationalization();
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classNames('k-scheduler-cell k-side-cell k-heading-cell', {
                'k-major-cell': !props.isLast
            }) }, (props.isMaster)
            ? intl.formatDate(slot.zonedStart, TIME_FORMAT)
            : null),
        children));
};
//# sourceMappingURL=DayViewRowContent.js.map